<template>
  <div class="foto-de-perfil">
    <a href="https://www.linkedin.com/in/mariaeduardaabreu/" target="_blank" rel="noopener noreferrer" class="foto-container">
      <img :src="fotoSrc" alt="Minha Foto" />
      <div class="borda-destaque"></div>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fotoSrc: require('@/assets/nova-foto2.png') 
    };
  }
};
</script>

<style scoped>
.foto-de-perfil {
  text-align: center;
}

.foto-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
  text-decoration: none; 
}

.foto-container img {
  width: 250px;
  height: 250px;
  border-radius: 50%;

  object-fit: cover;

  object-position: center 15%;

  z-index: 1;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.foto-container:hover img {
  transform: scale(1.05);
  box-shadow: 0 0 24px rgba(255, 143, 194, 0.45);
}

.borda-destaque {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 3px solid var(--border-color-blue);
  border-radius: 50%;
  z-index: 0;
  box-sizing: border-box;
  animation: girar 3s linear infinite;
  transition: border-color 0.3s ease;
}

.foto-container:hover .borda-destaque {
  border-color: var(--accent-pink);
}

@keyframes girar {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .foto-container img {
    width: 200px;
    height: 200px;
    object-position: center 10%;
  }
}
</style>